export enum NotificationSettingsLocations {
  ALL = 'ALL',
  SELECTED = 'SELECTED',
}
